import script from "./BvScrollTagging.vue?vue&type=script&lang=js"
export * from "./BvScrollTagging.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__